import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";
import blinkscribelogo from "../../../assets/blinkscribe 4.svg";
import { editpen } from "utils/svgs";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../api/api";
import axios from "axios";

const RaiseTicketAuth = ({ setModal, setOpen, setTMessage, setSeverity, ismodal, data }) => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [isEditable, setIsEditable] = useState(false);
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initializeUserInfo = async () => {
      const userEmail = data?.email || data?.useremail || "";
      const userName = data?.username || "";

      setEmail(userEmail);
      setUsername(userName);

      if (!userEmail && !userName) {
        try {
          setLoading(true);
          const response = await api.get("/auth/me");
          setEmail(response?.email || "");
          setUsername(response?.username || "");
        } catch (error) {
          console.error("Error fetching user info:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    initializeUserInfo();
  }, [data]);

  if (!ismodal) return null;

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
      setTMessage("File size exceeds 10MB limit.");
      setSeverity("error");
      setOpen(true);
      return;
    }
    setFile(selectedFile);
  };

const handleSubmit = async () => {
  const newErrors = {};
  if (!email.trim()) {
    newErrors.email = "Email is required.";
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    newErrors.email = "Invalid email address.";
  }
  if (!message.trim()) newErrors.message = "Message is required.";
  setErrors(newErrors);
  if (Object.keys(newErrors).length > 0) return;

  await sendEmail();
};

const sendEmail = async () => {
  setLoading(true);
  try {
    const formData = new FormData();

 const currentTime = new Date().toLocaleString("en-IN", {
  timeZone: "Asia/Kolkata",
  weekday: "short",
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
});

const htmlContent = `
  <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
    <p>Dear Support Team,</p>

    <p>A user has submitted a message via the <strong>Help & Support</strong> form. Below are the details:</p>

    <hr style="border: none; border-top: 1px solid #ccc;" />

    <h3 style="color: #156CFE; margin-top: 20px;">Message:</h3>
    <div style="background-color: #f4f8ff; padding: 12px; border-left: 4px solid #156CFE; border-radius: 4px;">
      ${message.replace(/\n/g, "<br/>")}
    </div>

    <h4 style="margin-top: 25px; margin-bottom: 5px;">User Details</h4>
    <ul style="list-style-type: none; padding-left: 0;">
      <li><strong>Email:</strong> ${email}</li>
      <li><strong>Username:</strong> ${username || "N/A"}</li>
      <li><strong>Submitted At:</strong> ${currentTime}</li>
    </ul>

    <hr style="border: none; border-top: 1px solid #ccc;" />

    <p style="margin-top: 25px;">Please respond as soon as possible.</p>

    <p>Best regards,<br/>System Notification - Help Desk</p>
  </div>
`;


    formData.append("to", "admin@brainymed.com");
    formData.append("subject", `New support request from ${username || email}`);
    formData.append("message", htmlContent);
    if (file) {
      formData.append("files", file);
    }

    await axios.post(`https://api.prd.brainymed.com/utility/send-email`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    setTMessage("Message sent successfully.");
    setSeverity("success");
    setOpen(true);
    setModal(false);
    setMessage("");
    setFile(null);
  } catch (error) {
    console.error("Email send failed:", error);
    setTMessage("Failed to send the message.");
    setSeverity("error");
    setOpen(true);
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-[#FFF] rounded-lg shadow-lg w-full max-w-5xl flex overflow-hidden relative">
        <button
          onClick={() => {
            setMessage("");
            setEmail(data?.email || "");
            setErrors({});
            setIsEditable(false);
            setModal(false);
          }}
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
        >
          <IoClose />
        </button>

        {/* Left Section */}
        <div className="w-full sm:w-[60%] p-10 text-start">
          <h3 className="text-lg font-semibold text-[#121212]">Get in Touch</h3>
          <h1 className="text-3xl font-bold mt-1 mb-2 text-[#0D141C]">
            Hello, {username || "there"}, let's chat!
          </h1>
          <p className="text-sm text-[#000] mb-6">
            We've pre-filled your details from your profile. Please confirm or edit them below.
          </p>

          <label className="block mb-2 text-sm font-normal text-gray-600">Email</label>
          <div className="relative mb-1">
            <input
              type="email"
              value={email}
              readOnly={!isEditable}
              onChange={(e) => setEmail(e.target.value)}
              className={`w-full border-b border-[#D1D5DC] py-2 pl-3 pr-10 bg-transparent text-gray-800 focus:outline-none transition duration-300 ${
                isEditable ? "border-blue-400 bg-white ring-1 ring-blue-100" : ""
              }`}
            />
            <span
              className="absolute right-2 top-[45%] transform -translate-y-1/2 text-gray-400 cursor-pointer z-50 bg-white"
              onClick={() => setIsEditable(!isEditable)}
            >
              {editpen}
            </span>
          </div>
          {errors.email && <p className="text-red-500 text-sm mb-2">{errors.email}</p>}

          <label className="block mb-2 text-sm font-normal text-gray-600 mt-4">Message</label>
          <textarea
            rows="6"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Let us know how we can help you.."
            className="w-full border-b border-[#D1D5DC] bg-transparent text-gray-800 px-3 py-2 text-sm resize-none focus:outline-none"
          />
          {errors.message && <p className="text-red-500 text-sm mb-2">{errors.message}</p>}

          <div
            className="border border-dashed border-[#CFDBE8] p-4 rounded mb-4"
            style={{ borderWidth: "2px", borderStyle: "dashed" }}
          >
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-[16px] font-semibold text-[#0D141C]">
                Attach a file <span className="text-sm font-normal">(Max 10MB)</span>
              </p>
              <label className="px-4 py-2 bg-[#E8EDF5] rounded-full text-sm font-medium cursor-pointer">
                Upload File
                <input type="file" onChange={handleFileChange} className="hidden" />
              </label>
            </div>
            {file && (
              <div className="flex items-center justify-between mt-3 bg-[#F8FAFC] p-2 rounded">
                <p className="text-sm text-[#1E293B] truncate">{file.name}</p>
                <button
                  onClick={() => setFile(null)}
                  className="text-gray-500 hover:text-red-600 text-lg font-bold ml-4"
                  title="Remove file"
                >
                  ×
                </button>
              </div>
            )}
          </div>

          <button
            onClick={handleSubmit}
            className="bg-[#156CFE] w-full sm:w-auto hover:bg-blue-700 text-white px-6 sm:px-10 py-3 rounded text-sm font-medium"
          >
            Send Message
          </button>
        </div>

        {/* Right Section */}
        <div
          className="w-[40%] p-10 hidden sm:flex justify-start text-start"
          style={{
            background: "linear-gradient(to bottom, white 0%, white 30%, #A2C6FDCC 100%)",
          }}
        >
          <div className="w-fit">
            <div className="w-full flex justify-end">
              <img src={blinkscribelogo} alt="blinkScribe Logo" className="w-[200px] mb-6" />
            </div>

            <p className="mb-1">You can also reach us at:</p>
            <div className="mt-4 flex gap-3 mb-4 flex-col">
              <p className="text-sm text-[#1E2939]">admin@brainymed.com</p>
              <p className="text-sm text-[#1E2939]">(682) 344 0264</p>
            </div>

            {/* <p className="text-sm text-[#0D141C]">For more information, visit our FAQ page.</p>
            <a href="#" className="text-blue-600 text-sm">
              Go to FAQ
            </a> */}
          </div>
        </div>


      </div>

      {/* Loading Spinner */}
      {loading && (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
          <CircularProgress color="inherit" size={40} />
        </Backdrop>
      )}
    </div>
  );
};

export default RaiseTicketAuth;
